import React, { useContext } from 'react'
import styled from "styled-components";
import { DilContext } from '../ContextDil';
const color1= '#f4f4f4';
const color2= '#3197EE';

const TopTitle = styled.div`
  width: 100%;
  display: flex;
  padding: 0.5rem;
  font-size: 1.5rem;
  font-weight: bold;
 
  
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.1);
`;

const Title = styled.div`
  width: 100%;
  display: flex;
  
  flex:0;
  
  justify-content: space-between;
  padding: 0.7rem 0.1rem;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.1);
`;

const TitleRight = styled.span`
  display: flex;
  flex-direction: column;
  width:20%;
  align-items: flex-end;
  text-align: right;
  font-size: 1rem;
  font-weight: bold;
  line-height: 1;
  color: red;
`;
const Radio = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 1rem;
  font-weight: bold;
  width:80%;
  line-height: 1;
 margin: 0.1rem;
  /* input[type="radio"] {
    position: absolute;
    opacity: 0;
    + .radio-label {
      &:before {
        content: '';
        background: ${color1};
        border-radius: 100%;
        border: 1px solid darken(${color1}, 25%);
        display: inline-block;
        width: 1.4em;
        height: 1.4em;
        position: relative;
        top: -0.1em;
        margin-right: 1em; 
        vertical-align: top;
        cursor: pointer;
        text-align: center;
        transition: all 250ms ease;
      }
    }
    &:checked {
      + .radio-label {
        &:before {
          background-color: ${color2};
          box-shadow: inset 0 0 0 4px ${color1};
        }
      }
    }
    &:focus {
      + .radio-label {
        &:before {
          outline: none;
          border-color: ${color2};
        }
      }
    }
    &:disabled {
      + .radio-label {
        &:before {
          box-shadow: inset 0 0 0 4px ${color1};
          border-color: darken(${color1}, 25%);
          background: darken(${color1}, 25%);
        }
      }
    }
    + .radio-label {
      &:empty {
        &:before {
          margin-right: 0;
        }
      }
    }
  } */
`;

const DetayLineChoise = ({price,ack,data}) => {
   // const [newdata, setNewdata] = useState([]);

    // useEffect(() => {
    //   //  {ALT_PR_KOD: '', ACIKLAMA: 'Yarım', PR_TR: '3', FIYAT: '35', DETDETID: '0'
    //  const objec={
    //     ALT_PR_KOD:"",
    //     ACIKLAMA:"Normal",
    //     PR_TR:"3",
    //     FIYAT:price,
    //     DETDETID:"0"
    //   }  
    //   setNewdata(data.concat(objec));
      

    // }, []);
   // console.log(newdata);
   
   const {lang} =useContext(DilContext);
    return (
       <>
            <TopTitle>{ack}</TopTitle>
            {data && data.map((res, index) => (
                <Title  key={index}>
                    {/* <Radio>
                        <input id={res.ACIKLAMA} name="radio" type="radio" />
                        <label for={res.ACIKLAMA} class="radio-label">{res.ACIKLAMA}</label>
                    </Radio> */}
                    <Radio>{res.DESCRIPTION}</Radio>
                    <TitleRight>{res.FIYAT} TL</TitleRight>
                </Title>
            ))}

        </>

    )
}

export default DetayLineChoise
